import LandingPageThemeSettingPanel from "./landingPageThemeSettingPanel.container";

export default LandingPageThemeSettingPanel;